import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { StorageEnum } from 'src/app/system/core/enums/StorageEnum';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/system/services/local-storage-service';
import { JobTitlePermissions} from 'src/app/system/admin/interfaces/permissions.interface'

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
private permissionsReady$ = new BehaviorSubject<boolean>(false);
public ready$ = this.permissionsReady$.asObservable();
private permissionsSubject = new BehaviorSubject<JobTitlePermissions | null>(null);
public permissions$ = this.permissionsSubject.asObservable();
 private staffUrl: string = environment.staffUrl;

  private _permissions!: JobTitlePermissions;
  private baseUrl: string = environment.baseUrl

   constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) { }

  getJobtitles(params?: any) {
    return this.http.get<{
      items: any[],
      page_size: number,
      page: number,
    }>(`${this.staffUrl}/catalogs/job_title_staff/`, { params }); 
  }

  initPermissions() {
    const jobTitleId = this.localStorageService.get(StorageEnum.JOB_TITLE_ID);

    if (jobTitleId) {
      this.loadPermissions(jobTitleId);
    }
  }

  deleteJobtitles(idJobTitle: string) {
    return this.http.delete<any[]>(`${this.staffUrl}/catalogs/job_title_staff/${idJobTitle}`)
  }

  addJobtitles(data: any) {
    return this.http.post<any[]>(`${this.staffUrl}/catalogs/job_title_staff/`, data)
  }


  loadPermissions(jobTitleId: string) {
    this.http
      .get<JobTitlePermissions>(`${this.staffUrl}/catalogs/job_title_staff/${jobTitleId}/`)
      .subscribe(jobTitle => {
        this.Permissions = jobTitle;
        this.permissionsSubject.next(jobTitle);
        this.permissionsReady$.next(true); 
      });
  }
  updateJobtitles( idJobTitle: string, data: any) {
    return this.http.put<any>(`${this.staffUrl}/catalogs/job_title_staff/${idJobTitle}/`, data)
  }

  get Permissions() {
    return this._permissions;
  }

  set Permissions(permissions: JobTitlePermissions) {
    this._permissions = permissions;
  }

hasPermission(moduleLabel: string): boolean {
  if (!this.Permissions) return false;
  return !!this.Permissions.permissions[moduleLabel];
}
}
